export default function NotFoundPage() {
  return (
    <main className="panel">
      <p className="status">404</p>
      <h1>Page not found</h1>
      <p className="muted">This QR code is not active, or the link was mistyped.</p>
      <hr />
    </main>
  );
}
